import {gql} from '@apollo/client';
import {USER_FRAGMENT} from '../fragments';

export const CREATE_USER = gql`
  ${USER_FRAGMENT}
  mutation createUser($input: UserInput!) {
    createUser(input: $input) {
      ...UserCoreFields
    }
  }
`;

export const DELETE_USER = gql`
  ${USER_FRAGMENT}
  mutation deleteUser($uid: ID!) {
    deleteUser(uid: $uid) {
      ...UserCoreFields
    }
  }
`;

export const ADD_TO_CLUB = gql`
  ${USER_FRAGMENT}
  mutation addToClub($uid: ID!, $clubId: ID!) {
    addToClub(uid: $uid, clubId: $clubId) {
      ...UserCoreFields
    }
  }
`;
